module.exports = __webpack_public_path__ + "img/Pellets-heizwert.806908d.png";